import type { EntitlementRepository } from "@/features/payment/entitlementRepository";
import { createEntitlementSnapshotFromBundleKeys } from "@/features/payment/entitlementSnapshot";
import { isBundleEntitlementKey } from "@/features/payment/paymentDefinitions";
import type {
  BundleEntitlementKey,
  EntitlementSnapshot,
} from "@/features/payment/types";

export interface OwnerEntitlements {
  readonly bundleKeys: readonly BundleEntitlementKey[];
  readonly snapshot: EntitlementSnapshot;
}

export async function loadEntitlementSnapshot(
  ownerId: string,
  repository: EntitlementRepository,
): Promise<OwnerEntitlements> {
  const rows = await repository.listForOwner(ownerId);
  const now = Date.now();
  const bundleKeys: BundleEntitlementKey[] = [];
  for (const row of rows) {
    if (
      row.expiresAt !== null &&
      Number.isFinite(Date.parse(row.expiresAt)) &&
      Date.parse(row.expiresAt) <= now
    ) {
      continue;
    }
    if (isBundleEntitlementKey(row.entitlementKey)) {
      bundleKeys.push(row.entitlementKey);
    }
  }
  return {
    bundleKeys,
    snapshot: createEntitlementSnapshotFromBundleKeys(bundleKeys),
  };
}
